import {FluidObject} from 'gatsby-image';
import {MyAccountQuery} from '../../pages/__generated__/MyAccountQuery';
import {TitleAndLinks} from '../../types/FooterContent';
import {OAuthOptions} from '../../utils/auth';
import {Plugin} from './index';

interface MyAccountData {
  footer: TitleAndLinks[];
  customerPortalBaseUrl: string;
  apiBaseUrl: string;
  oauthOptions: OAuthOptions;
  contentfulPlugins: Plugin[];
}

export const parseProps = (query: MyAccountQuery): MyAccountData => {
  const footer: TitleAndLinks[] = query.allContentfulGroupedLinks
    .nodes as TitleAndLinks[];
  const customerPortalBaseUrl =
    query?.site?.siteMetadata?.auth?.customerPortalBaseUrl || '';

  const contentfulPlugins = query.allContentfulProduct.edges.map(
    ({node}: any) => {
      return {
        slug: node.slug!,
        productName: node.title!,
        image: node?.slideshow?.[0]?.fluid as FluidObject,
        logo: node.logo?.file?.url!,
        softwareId: node.softwareId!,
      };
    }
  );

  const siteMetadata = query.site?.siteMetadata;
  const apiSettings = siteMetadata?.ampifyApi;
  const auth = siteMetadata?.auth;
  const apiBaseUrl = apiSettings?.baseUrl as string;
  const oauthOptions: OAuthOptions = {
    client_id: auth?.client_id as string,
    scope: auth?.scope as string,
  };

  return {
    footer,
    customerPortalBaseUrl,
    apiBaseUrl,
    oauthOptions,
    contentfulPlugins,
  };
};
